import type { ComponentProps } from "react";
import { InputWithLabel, SearchIcon } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";
import { View } from "tamagui";

type SearchInputProps = ComponentProps<typeof InputWithLabel>;

export const SearchInput: React.FC<SearchInputProps> = ({
  maxWidth,
  ...rest
}) => {
  const { t } = useTranslation("blocks");
  return (
    <View
      data-id="search-input-wrapper"
      maxWidth={maxWidth}
      width={"100%"}
      position={"relative"}
      justifyContent="center"
    >
      <InputWithLabel
        variant="underlined"
        placeholder={t("search-component.placeholder")}
        rounded="none"
        size="sm"
        {...rest}
      />
      <View position="absolute" right={0}>
        <SearchIcon />
      </View>
    </View>
  );
};
